import React from "react";
import { useLocation } from "react-router-dom";
import { LogEvents, LoggerContext } from "../../../context/logging";

export const PageViewTracker = () => {
  const logger = React.useContext(LoggerContext);
  const location = useLocation();

  React.useEffect(() => {
    logger.log(LogEvents.PageView, {
      page: location.pathname,
    });
  }, [location, logger]);

  return (
    <React.Fragment />
  )
}